"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  RESISTANCE_COEF: 0.6,

  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 // px
};


// WEBPACK FOOTER //
// ./node_modules/react-swipeable-views-core/lib/constant.js